import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { Row, Col, Form, Button, Modal, Spinner, Tab, Nav, Card, Alert } from 'react-bootstrap';
import { Information } from 'iconsax-react';

import Select from 'react-select';
import { sidSelectStyles } from '../../../../components/Util/sidSelectStyles';
import { usePageTitle } from '../../../../layouts/PageHeaderExtra';
import { motivoPrenotazioniFuture, useStatoNelTitolo } from '../../../../components/Util/StatoProdotto';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports, tipologiaStruttura } from '../../../../components/Util/enum';
import { CampoSport, sportDelProdotto, sportDaSalvare } from '../../../../components/Util/sportProdotto';
import { useProfile } from '../../../../../hooks/useProfile';
import DisponibilitaImpianto from '../../../../components/Impianti/disponibilitaImpianto';
import LinkAcquisto from '../../../../components/LinkAcquisto/LinkAcquisto';
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from '../../../../components/Util/vatOptions';
import { conMotivo } from "../../../../components/Util/erroreServer";
import UserVenuesTable from '../userFacilities/index';
import { numeroDaTesto } from "../../../../components/Util/prezzi";
import AvvisoFatturazione from '../../../../components/Util/AvvisoFatturazione';
import { segnalaMancanti } from '../../../../components/Util/campiMancanti';

export const FacilitiesEdit = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    // ?tab=disponibilita: dopo la creazione dell'impianto si arriva direttamente sugli orari
    const tabIniziale = new URLSearchParams(useLocation().search).get('tab') === 'disponibilita' ? 'disponibilita' : 'informazioni';

    const { profile: profileData } = useProfile({
        autoFetch: true
    });
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED' && profileData?.club?.profileStatus !== 'INACTIVE';

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');
	// Conferma dell'eliminazione dell'impianto (prima nel menu a fine riga della lista)
	const [confirmDeleteShowed, setConfirmDeleteShowed] = useState(false);

    const [enabledSports, setEnabledSports] = useState([]);

    // Stato per gestire i metodi di pagamento abilitati
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    const [formData, setFormData] = useState({
        id: '',
        name: '', 
        description: '',
        sportTypes: [],
        multiCourse: false,
        showToCustomers: false,
        // Nuovi campi per prezzi e disponibilità
        payable_stripe: false,
        payable_bank: false,
        payable_in_club: false,
        standard_price: 0,
        vat_rate: 22,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0
    });

    // Titolo della pagina con il nome dell'impianto (appena caricato)
    usePageTitle(formData?.name || null); // titolo = solo il nome del prodotto

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Campi si'/no: un interruttore su una riga (stessi valori true/false delle vecchie tendine)
    const renderSwitchField = (fieldName, label) => (
        <div className="sid-switch-row">
            <Form.Check
                type="switch"
                id={`switch-${fieldName}`}
                label={label}
                checked={formData[fieldName] === true || formData[fieldName] === 'true'}
                onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
            />
        </div>
    );

    // Dati dell'impianto per updateVenue (salvataggio della scheda e cambio di stato dalla chip nel titolo)
    const datiImpianto = (fd, mostra) => ({
        name: fd.name.trim(),
        description: fd.description ? fd.description.trim() : '',
        ...sportDaSalvare(fd.sportTypes),
        multiCourse: fd.multiCourse === true || fd.multiCourse === 'true',
        showToCustomers: mostra,
        // Nuovi campi per prezzi e disponibilità
        payable_stripe: fd.payable_stripe === true || fd.payable_stripe === 'true',
        payable_bank: fd.payable_bank === true || fd.payable_bank === 'true',
        payable_in_club: fd.payable_in_club === true || fd.payable_in_club === 'true',
        standard_price: numeroDaTesto(fd.standard_price) || 0,
        member_price: numeroDaTesto(fd.member_price) || 0,
        federated_price: numeroDaTesto(fd.federated_price) || 0,
        fitcoin_cashback: numeroDaTesto(fd.fitcoin_cashback) || 0,
        vat_rate: fd.vat_rate,
        // undefined viene omesso dal JSON: fuori dallo 0% la Natura non
        // deve proprio esserci, o lo SDI scarta la fattura.
        // Vuota ("" come la rimanda il server) vale come assente: il server non accetta "".
        vat_nature: fd.vat_nature || undefined
    });

    // Stato dalla chip accanto al titolo (Attivo = visibile e acquistabile dai clienti). Si registra subito
    // e si resta nella scheda. Non si mette Non attivo se ci sono prenotazioni dai prossimi giorni in poi.
    // `archivia` (TASK #7): la voce «Archiviato» della tendina; archiviato vuol dire anche non visibile ai clienti
    const cambiaStato = async (attiva, archivia = false) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        if (!attiva) {
            const prenotazioni = await apiClient.getUserBookingVenues(token, formData.id);
            if (prenotazioni?.error) return { error: prenotazioni.error };
            const motivo = motivoPrenotazioniFuture(prenotazioni, 'l’impianto');
            if (motivo) return { error: motivo };
        }
        const risposta = await apiClient.updateVenue(token, formData.id, { ...datiImpianto(formData, attiva), archived: archivia });
        if (risposta?.error) return { error: risposta.error };
        setFormData(prev => ({ ...prev, showToCustomers: attiva, archived: archivia }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.id,
        attivo: !!formData?.showToCustomers && formData.showToCustomers !== 'false',
        archiviato: !!formData?.archived,
        onCambia: cambiaStato,
    });

    const handleSaveClick = () => {
        // Dati mancanti: si evidenzia il campo (regola «Dati mancanti»), niente bolla del browser
        const mancanti = [];
        if (!formData.name || !String(formData.name).trim()) mancanti.push({ campo: 'imp-name', messaggio: "Manca il nome dell'impianto" });
        if (!formData.sportTypes.length) mancanti.push({ campo: 'imp-sport', messaggio: 'Manca lo sport' });
        if (segnalaMancanti(mancanti) > 0) return;
        handleSave();
    };

	const tabData = [
		{
			name: "Informazioni generali",
			key: "informazioni",
			icon: <i className="fas fa-info-circle me-2"></i>,
			content: (
				<Card>
					<Card.Body className="sid-card-body--spaced">
						<Form id="facilitiesForm" noValidate>
							<Row className="g-4">
								<Col md={6}>
									<Form.Label className="mb-2" htmlFor="imp-name">Impianto / Ritrovo *</Form.Label>
									<Form.Control
										id="imp-name"
										className="mt-2"
										type="text"
										name="name"
										value={formData.name}
										onChange={handleChange}
									/>
								</Col>
								<Col md={6}>
									<Form.Label className="mb-2" htmlFor="imp-sport">Sport *</Form.Label>
									<CampoSport
										inputId="imp-sport"
										valore={formData.sportTypes}
										onChange={(elenco) => setFormData(prev => ({ ...prev, sportTypes: elenco }))}
										opzioni={enabledSports}
									/>
								</Col>
								<Col md={12}>
									<Form.Label className="mb-2">Descrizione</Form.Label>
									<Form.Control
										className="mt-2"
										as="textarea"
										rows={3}
										name="description"
										value={formData.description || ''}
										onChange={handleChange}
									/>
								</Col>
							</Row>
							<div className="sid-switch-inline mt-4">
								{renderSwitchField("multiCourse", "Multi corso")}
								{!id && renderSwitchField("showToCustomers", "Mostra ai clienti")}
							</div>

							<h5 className="sid-form-section">Prezzi</h5>
							<Row className="g-4">
								<Col md={3}>
									<Form.Label className="mb-2">Prezzo standard</Form.Label>
									<Form.Control
										className="mt-2"
										type="number"
										min="0"
										step="0.01"
										name="standard_price"
										value={formData.standard_price}
										onChange={handleChange}
									/>
								</Col>
								<Col md={3}>
									<Form.Label className="mb-2">IVA</Form.Label>
									<Select
										className="mt-2"
										styles={sidSelectStyles}
										name="vat_rate"
										value={findVatOption(formData)}
										onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
										options={VAT_OPTIONS}
									/>
								</Col>
								{showingTesseratiOptions && (
								<Col md={3}>
									<Form.Label className="mb-2">Prezzo tesserati / soci</Form.Label>
									<Form.Control
										className="mt-2"
										type="number"
										min="0"
										step="0.01"
										name="federated_price"
										value={formData.federated_price}
										onChange={handleChange}
									/>
								</Col>
								)}
								<Col md={3}>
									<Form.Label className="mb-2">Cashback Fitcoin</Form.Label>
									<Form.Control
										className="mt-2"
										type="number"
										min="0"
										step="0.01"
										name="fitcoin_cashback"
										value={formData.fitcoin_cashback}
										onChange={handleChange}
									/>
								</Col>
							</Row>

							<h5 className="sid-form-section">Forme di pagamento</h5>
							<div className="sid-switch-inline">
								{renderSwitchField("payable_in_club", "Acquisto pagabile in struttura")}
								{paymentMethods.stripe_enabled && renderSwitchField("payable_stripe", "Acquisto pagabile su Stripe")}
								{paymentMethods.bank_transfer_enabled && renderSwitchField("payable_bank", "Acquisto pagabile con bonifico")}
							</div>
						</Form>
					</Card.Body>
				</Card>
			),
		},
		{
			name: "Disponibilità",
			key: "disponibilita",
			icon: <i className="fas fa-calendar-alt me-2"></i>,
			content: <DisponibilitaImpianto venueId={id} />,
		},
		{
			name: "Prenotazioni",
			key: "acquisti",
			icon: <i className="fas fa-shopping-cart me-2"></i>,
			content: (
				<UserVenuesTable
					venue_id={id}
					headerButtons={(
						<Link to={`/struttura/booking/userFacilities?venueId=${id}`} className="btn btn-primary btn-sm btn-add">
							<i className="fas fa-plus me-2"></i>
							Nuova Vendita
						</Link>
					)}
				/>
			),
		}
	];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const venues = await apiClient.getVenues(token);
                    setLoadingShowed(false);

                    const venue = venues.find(v => v.id === id);
                    if(venue) {
                        const elementFormData = {
                            id: venue.id,
                            name: venue.name, 
                            description: venue.description,
                            sportTypes: sportDelProdotto(venue),
                            multiCourse: venue.multiCourse || false,
                            showToCustomers: venue.showToCustomers || false,
                            archived: !!venue.archived,
                            // Nuovi campi per prezzi e disponibilità
                            payable_stripe: venue.payable_stripe || false,
                            payable_bank: venue.payable_bank || false,
                            payable_in_club: venue.payable_in_club || false,
                            standard_price: venue.standard_price || 0,
                            member_price: venue.member_price || 0,
                            federated_price: venue.federated_price || 0,
                            fitcoin_cashback: venue.fitcoin_cashback || 0,
                            // `??` e non `||`: con vat_rate = 0 un OR riporterebbe al 22%.
                            vat_rate: venue.vat_rate ?? 22,
                            vat_nature: venue.vat_nature
                        };
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoadingShowed(false);
            }
        };

        fetchData();
    }, [id]);

    // useEffect per inizializzare i metodi di pagamento dai dati del token
    useEffect(() => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, []);

    useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }
    }, [profileData]);

    const handleSave = async () => {
        try {
            setLoadingShowed(true);
            
            // Se non mostriamo le opzioni soci, impostiamo federated_price uguale a standard_price
            if(!showingSociOptions) {
                formData.grants_club_membership = false;
                formData.member_price = formData.standard_price;
            }
            if(!showingTesseratiOptions) {
                formData.grants_federated_status = false;
                formData.federated_price = formData.standard_price;
            }
            
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const venueData = datiImpianto(formData, formData.showToCustomers !== false && formData.showToCustomers !== 'false');

                const response = await apiClient.updateVenue(token, formData.id, venueData);
                setLoadingShowed(false);

                if (response.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(response.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/facilities');
                }
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error("Error saving venue:", error);
            setModalTitle("Errore durante l'operazione");
            setModalText(conMotivo("Si è verificato un errore durante il salvataggio"));
            setModalShowed(true);
        }
    };

	// Eliminazione dell'impianto: spostata qui dalla lista (booking/facilities/index.js)
	const continueDelete = () => {
		setConfirmDeleteShowed(false);

		const deleteData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					const token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const deleteResult = await apiClient.deleteVenue(token, formData.id);
					setLoadingShowed(false);

					if (deleteResult && deleteResult.error) {
						setModalTitle("Errore durante l'operazione");
						setModalText(deleteResult.error);
						setModalShowed(true);
					} else {
						navigate('/struttura/booking/facilities');
					}
				}
			} catch (error) {
				setLoadingShowed(false);
				console.error("Error fetching data:", error);
			}
		};

		deleteData();
	};

	return (
		<>
			<Modal className="fade" show={confirmDeleteShowed} centered>
				<Modal.Header>
					<Modal.Title>Eliminare l'impianto?</Modal.Title>
					<Button onClick={() => setConfirmDeleteShowed(false)} variant="" className="btn-close"></Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col>Vuoi eliminare l'impianto <strong>{formData.name}</strong>? L'operazione non è reversibile.</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-center sid-footer-conferma">
					<Button className="btn btn-light btn-add" onClick={() => setConfirmDeleteShowed(false)}>Annulla</Button>
					<Button className="btn btn-danger btn-add" onClick={continueDelete}>Elimina</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
					<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			{billingNotConfirmed && (
				<AvvisoFatturazione />
			)}

			<div className="custom-tab-1">
				<Tab.Container defaultActiveKey={tabIniziale}>
					<div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link eventKey={data.key}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					{/* Link pubblico per prenotare l'impianto: il cliente sceglie giorno e orario libero */}
					{id && <LinkAcquisto productType="venue" productId={id} nomeProdotto={formData.name} attivo={!!formData.showToCustomers && formData.sportTypes.length > 0} />}
					</div>
					<Row className="align-items-start mt-4">
						<div className="col-xl-9">
							<Tab.Content mountOnEnter>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.key} key={i}>
										{data.content}
										{data.key === 'informazioni' && (
											<div className="d-flex justify-content-between mt-4">
												<button type="button" className="btn btn-danger light" onClick={() => setConfirmDeleteShowed(true)}>Elimina</button>
												<div className="d-flex gap-4">
												<Button
													variant="primary"
													className="btn btn-primary"
													onClick={handleSaveClick}
													disabled={loadingShowed}
												>
													Salva Modifiche
												</Button>
												</div>
											</div>
										)}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
						<div className="col-xl-3">
							<Card>
								<Card.Body className="text-center">
									<h4 className="text-start mb-0 mt-4 text-warning">{formData.name}</h4>
									<p className="text-start mt-0 pt-0">Impianto Sportivo</p>
									<p className="text-start mt-2">{formData.description}</p>
								</Card.Body>
							</Card>
						</div>
					</Row>
				</Tab.Container>
			</div>
		</>
	);
};

export default FacilitiesEdit;